import React, { useState } from 'react';
import clsx from 'clsx';
import Icon from '@material-ui/core/Icon';
import { withStyles } from '@material-ui/core/styles';
import Hidden from '@material-ui/core/Hidden';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import AnalyticsWrapper from '@configuratorware/configurator-frontendgui/App/Shared/Components/Analytics/AnalyticsWrapper';
import customClassName from '@configuratorware/configurator-frontendgui/App/Utils/customClassName';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import CloudDownloadIcon from '../Resources/Icons/CloudDownloadIcon.svg';
import PictureAsPdfIcon from '../Resources/Icons/PictureAsPdfIcon.svg';
import MailIcon from '../Resources/Icons/MailIcon.svg';
import CloudUploadIcon from '../Resources/Icons/CloudUploadIcon.svg';

const iconMap = {
  cloud_download: CloudDownloadIcon,
  cloud_upload: CloudUploadIcon,
  mail: MailIcon,
  picture_as_pdf: PictureAsPdfIcon,
};

const styles = (theme) => ({
  iconHover: {
    margin: theme.spacing(1),
    textAlign: 'center',
    verticalAlign: 'middle',
    lineHeight: '24px',
    width: '24px',
    height: '24px',
    '&:hover': {
      color: 'rgba(0,0,0, 0.5)',
      cursor: 'pointer',
    },
  },
  root: {
    whiteSpace: 'nowrap',
  },
  ToolbarButton: {
    padding: 0,
  },
  ToolbarIconButton: {
    height: 40,
    width: 40,
    padding: 8,
    '& span': {
      fontSize: '32px !important',
      color: theme.palette.primary.darkText,
    },
  },
  MenuItemOption: {
    '@media (hover: none) , (pointer: coarse)': {
      '&:focus': {
        backgroundColor: '#fff',
      },
    },
  },
  toolTitle: {
    alignSelf: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: 175,
  },
});
const ITEM_HEIGHT = 52;

const ToolbarList = (prop) => {
  const { classes, tools } = prop;

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const toolbarMobileIcon = !open ? 'menu' : 'close';

  tools.splice(1, 0, tools.splice(0, 1)[0]);

  return (
    <div className={clsx(classes.root, customClassName('tools'))}>
      {tools && (
        <Hidden xsDown>
          {tools.map((tool) => {
            return (
              <AnalyticsWrapper key={tool.key} targetId={tool.key}>
                <IconButton
                  title={tool.title && t(tool.title)}
                  key={tool.key}
                  className={classes.iconHover}
                  onClick={tool.function}
                >
                  <img src={iconMap[tool.identifier]} alt={`${tool.identifier} icon`} />
                </IconButton>
              </AnalyticsWrapper>
            );
          })}
        </Hidden>
      )}
      <Hidden smUp>
        <div>
          <IconButton
            aria-label="Menu"
            aria-haspopup="true"
            classes={{
              root: classes.ToolbarButton,
              label: classes.ToolbarIconButton,
            }}
            onClick={handleClick}
          >
            <Icon>{toolbarMobileIcon}</Icon>
          </IconButton>
          <Menu
            id="long-menu"
            anchorEl={anchorEl}
            open={open}
            getContentAnchorEl={null}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            transformOrigin={{ vertical: 'top', horizontal: 'center' }}
            onClose={handleClose}
            PaperProps={{
              style: {
                maxHeight: ITEM_HEIGHT * 4.5,
                width: 250,
              },
            }}
          >
            {tools &&
              tools.map((tool) => (
                <MenuItem className={classes.MenuItemOption} key={tool.key} onClick={handleClose}>
                  <AnalyticsWrapper key={tool.key} targetId={tool.key}>
                    <div style={{ display: 'flex', width: '100%' }} onClick={tool.function}>
                      <Icon key={tool.key} className={classes.iconHover}>
                        {tool.identifier}
                      </Icon>
                      <div className={classes.toolTitle}>{tool.title && t(tool.title)}</div>
                    </div>
                  </AnalyticsWrapper>
                </MenuItem>
              ))}
          </Menu>
        </div>
      </Hidden>
    </div>
  );
};

export default withStyles(styles, { name: 'ToolbarList' })(ToolbarList);
